export class SearchIndex {
    constructor(options = {}) {
        this.cx = options.cx || "007149992689784155822:xiyts3ie9mc";
        this.searchScope = options.searchScope || null;
        this.init();
    }

    init() {
        this.addEventHandlers();
        this.initGoogleSearch();
    }

    addEventHandlers() {
        $(document).on("click", "button.gsc-search-button",
            function () {
                $("#searchresults").show();
            });

        $(document).on("click", "a.gsst_a, #reset-search-btn",
            function () {
                $("#searchresults").hide();
            });
    }

    initGoogleSearch() {
        const cx = this.cx;
        const searchScope = this.searchScope;

        const onDomReady = (fn) => {
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", fn, { once: true });
            } else {
                fn();
            }
        };

        const showResults = () => {
            const resultsHost = document.getElementById("searchresults");

            if (!resultsHost) {
                return;
            }

            resultsHost.hidden = false;
            resultsHost.classList.add("has-results");
        };

        const hideResults = () => {
            const resultsHost = document.getElementById("searchresults");

            if (!resultsHost) {
                return;
            }

            resultsHost.hidden = true;
            resultsHost.classList.remove("has-results");
        };

        const wireUpSearch = () => {
            const form = document.getElementById("siteSearchForm");
            const input = document.getElementById("q");
            const resultsHost = document.getElementById("searchresults");

            if (!form || !input) {
                return;
            }

            const execute = (query) => {
                const el = window.google?.search?.cse?.element
                    ?.getElement("searchresults");

                if (!el) {
                    return;
                }

                showResults();

                const scopedQuery = searchScope
                    ? `${searchScope} ${query}`
                    : query;

                el.execute(scopedQuery);
            };

            form.addEventListener("submit", (e) => {
                e.preventDefault();

                const query = input.value.trim();

                if (!query) {
                    return;
                }

                // Keep only the user's query in the URL.
                const url = new URL(window.location.href);
                url.searchParams.set("q", query);

                history.pushState(null, "", url.toString());

                execute(query);
            });

            input.addEventListener("search", () => {
                if (input.value !== "") {
                    return;
                }

                hideResults();

                const url = new URL(window.location.href);
                url.searchParams.delete("q");

                history.pushState(
                    null,
                    "",
                    url.pathname + url.search
                );
            });

            // Auto-search if ?q= is present.
            const q = new URLSearchParams(window.location.search)
                .get("q");

            if (q) {
                input.value = q;
                execute(q);
                resultsHost?.classList.add("has-results");
            }
        };

        window.__gcse = {
            parsetags: "onload",
            initializationCallback: () => {
                onDomReady(wireUpSearch);
            }
        };

        // Load PSE script once.
        if (!window.__PSE_LOADED__) {
            window.__PSE_LOADED__ = true;

            const script = document.createElement("script");

            script.async = true;
            script.src = `https://cse.google.com/cse.js?cx=${cx}`;

            document.head.appendChild(script);
        }
    }
}